import { Link } from "react-router-dom";
import { Phone, MapPin, Facebook, Instagram } from "lucide-react";
import { CHURCH } from "@/data/church";

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-gradient-to-b from-[#3B0764] to-[#24073B] text-[#E9E4DA]">
    <div className="mx-auto max-w-7xl px-5 py-14 sm:px-8 sm:py-16">
      <div className="grid gap-12 md:grid-cols-3">
        <div>
          <p className="font-serif text-2xl font-semibold text-[#FBF9F5]">
            Stafford Spiritualist Church
          </p>
          <p className="mt-5 max-w-sm text-base leading-relaxed text-[#B8BFC9]">
            A warm and peaceful spiritual home in the heart of Stafford. Everyone is
            welcome — whatever your beliefs, background or experience.
          </p>
        </div>

        <div>
          <p className="text-sm font-semibold uppercase tracking-widest text-[#C59B4B]">
            Visit Us
          </p>
          <address className="mt-4 not-italic text-base leading-relaxed text-[#B8BFC9]">
            {CHURCH.addressLines.map((line) => (
              <span key={line} className="block">
                {line}
              </span>
            ))}
          </address>
          <p className="mt-4 text-base text-[#B8BFC9]">
            Sunday Divine Service · {CHURCH.serviceTime}
            <span className="block text-sm text-[#8d96a3]">{CHURCH.healingNote}</span>
          </p>
        </div>

        <div>
          <p className="text-sm font-semibold uppercase tracking-widest text-[#C59B4B]">
            Get in Touch
          </p>
          <a
            href={CHURCH.phoneHref}
            data-testid="footer-phone-link"
            className="mt-4 inline-flex items-center gap-3 text-xl font-semibold text-[#FBF9F5] transition-colors hover:text-[#C59B4B]"
          >
            <Phone className="h-5 w-5" aria-hidden="true" />
            {CHURCH.phoneDisplay}
          </a>
          <div className="mt-5 flex gap-3">
            <a
              href={CHURCH.facebook}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-facebook-link"
              aria-label="Visit our Facebook page"
              className="inline-flex min-h-12 min-w-12 items-center justify-center rounded-xl border border-white/15 text-[#B8BFC9] transition-colors hover:border-[#C59B4B] hover:text-[#C59B4B]"
            >
              <Facebook className="h-5 w-5" aria-hidden="true" />
            </a>
            <a
              href={CHURCH.instagram}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-instagram-link"
              aria-label="Visit our Instagram page"
              className="inline-flex min-h-12 min-w-12 items-center justify-center rounded-xl border border-white/15 text-[#B8BFC9] transition-colors hover:border-[#C59B4B] hover:text-[#C59B4B]"
            >
              <Instagram className="h-5 w-5" aria-hidden="true" />
            </a>
            <a
              href={CHURCH.mapsUrl}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-map-link"
              aria-label="Find us on Google Maps"
              className="inline-flex min-h-12 min-w-12 items-center justify-center rounded-xl border border-white/15 text-[#B8BFC9] transition-colors hover:border-[#C59B4B] hover:text-[#C59B4B]"
            >
              <MapPin className="h-5 w-5" aria-hidden="true" />
            </a>
          </div>
          <nav className="mt-6 flex flex-wrap gap-x-5 gap-y-2 text-sm" aria-label="Footer">
            <Link to="/" data-testid="footer-link-home" className="text-[#B8BFC9] hover:text-[#C59B4B]">Home</Link>
            <Link to="/events" data-testid="footer-link-events" className="text-[#B8BFC9] hover:text-[#C59B4B]">Posters & Events</Link>
            <Link to="/news" data-testid="footer-link-news" className="text-[#B8BFC9] hover:text-[#C59B4B]">News</Link>
            <Link to="/contact" data-testid="footer-link-contact" className="text-[#B8BFC9] hover:text-[#C59B4B]">Contact</Link>
          </nav>
        </div>
      </div>
    </div>
    <div className="border-t border-white/10">
      <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-2 px-5 py-6 text-sm text-[#8d96a3] sm:flex-row sm:px-8">
        <p>© {new Date().getFullYear()} Stafford Spiritualist Church, Northfield Centre.</p>
        <p>{CHURCH.website}</p>
        <p>Everyone is Welcome · Sundays at 6:30pm</p>
      </div>
    </div>
  </footer>
);
